import React from 'react';
import useAds from '../../hooks/useAds';

interface AdComponentProps {
    adsenseSlot?: string;
    className?: string;
    style?: React.CSSProperties;
}

const AdComponent: React.FC<AdComponentProps> = ({
    adsenseSlot,
    className = '',
    style = {}
}) => {
    const { deviceType, isAdLoaded, error } = useAds({
        desktopBreakpoint: 1024,
        isTesting: true,
        admobBannerId: 'tu-id-personalizado'
    });

    // Para móvil, no necesitamos renderizar nada ya que AdMob maneja su propio UI
    if (deviceType === 'mobile') {
        return null;
    }

    // Para desktop, renderizamos el anuncio de AdSense
    if (deviceType === 'desktop' && isAdLoaded) {
        return (
            <ins
                className={`adsbygoogle ${className}`}
                style={{
                    display: 'block',
                    ...style
                }}
                data-ad-client={import.meta.env.VITE_PUBLIC_ADSENSE_CLIENT_ID}
                data-ad-slot={adsenseSlot}
                data-ad-format="auto"
                data-full-width-responsive="true"
            />
        );
    }

    // Si hay un error y estamos en desarrollo, mostramos el error
    if (error && process.env.NODE_ENV === 'development') {
        return <div className="text-red-500">Error: {error}</div>;
    }

    return null;
};

export default AdComponent;